module.exports = __webpack_public_path__ + "static/media/_ARK2991.c86e29ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cafeteria/_ARK2991.jpg
// module id = 1150
// module chunks = 0